import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  headline() {
    return faker.lorem.sentence();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(collection, server) {
    let numArtists = faker.datatype.number({
      min: 1,
      max: 3,
    });

    collection.update({
      artists: server.createList('artist', numArtists),
      assets: server.createList('asset', 1),
    });
  },
});
